import parser from './parser';

const name = 'upload';


export default {parser, name};
